import React, { Component, createRef } from "react";
import { Spine } from "./spine";
import {
  IconButton,
  Card,
  CardContent,
} from "@material-ui/core";
import HomeIcon from '@material-ui/icons/Home';
import CardActionArea from '@material-ui/core/CardActionArea';
import parser from "../utils/skel";
import isMobile from "../utils/isMobile";
export default class SpineViewer extends Component {
  constructor() {
    super();
    const spineData = JSON.parse(
      document.getElementById("SPINEDATA").innerHTML
    );
    const indexData = JSON.parse(
      document.getElementById("INDEXDATA2").innerHTML
    )
    this.spineData = spineData.skin;
    this.name = spineData.name;
    this.prefix = spineData.prefix;
    this.skinIndex = indexData.skinIndex;
    this.aniIndex = 0;
    this.modelIndex = 0;
    this.skinList = Object.keys(this.spineData);
    // Object.keys(spineData);
    // console.log(spineData);
    this.reset = this.reset.bind(this);
    this.changeModel = this.changeModel.bind(this);
    this.nextAnimation = this.nextAnimation.bind(this);
    //this.onLoopChange = this.onLoopChange.bind(this);
    //this.onClickFullScreen = this.onClickFullScreen.bind(this);
    //this.encode = this.encode.bind(this);
    this.animationsData = [];
    this.state = {
      color: "00000000",
      speed: 1,
      animations: [],
      animation: "",
      loop: true,
      openInfo: false,
      skin: this.skinList[this.skinIndex],
      modelList: Object.keys(this.spineData[this.skinList[this.skinIndex]]),
      model: Object.keys(this.spineData[this.skinList[this.skinIndex]])[0],
      loading: true,
      json: {},
      fullscreen: false,
      scale: 0.3,
      building: false,
      progress: 0,
    };
    this.spineRef = createRef();
    this.rootRef = createRef();
    this.loopRef = createRef();
    this.isMobile = isMobile();
  }
  reset() {
    if (!this.state.loading) {
      this.spineRef.current.reset();
    }
  }
  // onLoopChange(e) {
  //   // console.log(e.target.checked);
  //   this.setState({ loop: e.target.checked });
  //   if (!this.state.loading && !this.state.building) {
  //     this.spineRef.current.updateAnimation(
  //       this.state.animation,
  //       e.target.checked
  //     );
  //   }
  // }
  changeModel(){
    if(this.modelIndex == 0){
      this.modelIndex = 2;
    } else {
      this.modelIndex = 0;
    }
    const value = this.state.modelList[this.modelIndex];
    this.setState({
      model : value,
      animation : "",
      animations : [],
      loading: true,
    });
    this.loadData(this.state.skin, value);
  }

  nextAnimation() {
    this.aniIndex++;
    if(this.aniIndex >= this.state.animations.length) this.aniIndex = 0;
    this.setState({animation: this.state.animations[(this.aniIndex)]});
    if(!this.state.loading){
      this.spineRef.current.updateAnimation(this.state.animations[(this.aniIndex)], this.state.loop);
    }
  }
  componentDidMount() {
    // this.rootRef.current.addEventListener("fullscreenchange", () => {
    //   if (document.fullscreenElement) {
    //     this.setState({
    //       scale:
    //         Math.min(
    //           document.documentElement.clientHeight - 40,
    //           document.documentElement.clientWidth - 314
    //         ) / 1000,
    //     });
    //   } else {
    //     this.setState({
    //       fullscreen: false,
    //       scale: 0.3,
    //     });
    //   }
    // });
    this.loadData(
      this.skinList[this.skinIndex],
      Object.keys(this.spineData[this.skinList[this.skinIndex]])[0]
    );
  }
  loadData(skin, model) {
    parser(this.prefix + this.spineData[skin][model].file + ".skel").then(
      (data) => {
        // console.log(data);
        const animations = Object.keys(data.animations);
        this.setState({
          json: data,
          animations: animations,
          animation: animations[0],
        });
        this.spineRef.current.loadWidget(
          data,
          this.prefix + this.spineData[skin][model].file + ".atlas",
          animations[0],
          this.state.color,
          this.state.loop,
          this.spineData[this.state.skin][this.state.model].skin || "default",
          this.state.speed,
          (aniData) => {
            this.animationsData = aniData;
            this.setState({ loading: false });
          }
        );
      }
    );
  }
  render() {
    return (
      <div style={{ width: "fit-content", position: "relative" }}>
        <Card
          ref={this.rootRef}
          style={{ backgroundColor: '#00000000', display: "flex", width: "fit-content", boxShadow: "none" }}
        >
          <CardActionArea
            onClick={() => {this.nextAnimation()} }>
            <CardContent
            style = {{padding: 0}}
            >
            <Spine
              ref={this.spineRef}
              scale={this.state.scale}
              loading={this.state.loading}
            >
            </Spine>
            </CardContent>
          </CardActionArea>
          <IconButton
                  style = {{backgroundColor: '#00000000', position: 'absolute', zIndex: 1, left: 10, top: 170, width:30, height: 30}}
                  onClick={() => {
                    this.changeModel()
                  }}
                >
                  <HomeIcon></HomeIcon>
          </IconButton>
        </Card>
      </div>
    );
  }
}
